<template>
  <div class="d-flex flex-wrap">
    <div class="col-12 col-lg-4 d-flex flex-wrap">
      <OrdersMapSummary :data="summary" :ordersQuantity="ordersQuantity" />
    </div>

    <div id="map-wrapper" class="col-12 col-lg-8" style="position: relative">
      <FranceMapSvg :default-color="defaultColor" />

      <div
        v-show="currentHoveredId && hoveredDepartmentData"
        id="data-card"
        class="card data-card"
      >
        <template v-if="hoveredDepartmentData && hoveredDepartmentData.data">
          <div class="card-header font-weight-bold">
            {{ hoveredDepartmentData.label }}
          </div>

          <div class="card-body" v-if="hoveredDepartmentData.data.length > 0">
            <OrdersMapSummary
              :data="hoveredDepartmentData"
              :ordersQuantity="hoveredDepartmentData.data.length"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import OrdersMapSummary from "@/components/order/OrdersMapSummary.vue";
import FranceMapSvg from "@/components/utils/FranceMapSvg";

export default {
  components: { OrdersMapSummary, FranceMapSvg },

  props: {
    ordersSortedByDepartment: { type: Array, required: true },
    summary: { type: Object, required: true },
    ordersQuantity: { type: Number, required: true },
  },

  data() {
    return {
      currentHoveredId: null,
      dataCardPositionIsSet: false,
    };
  },

  mounted() {
    this.setPathsListeners();
  },

  computed: {
    ...mapGetters({
      defaultColor: "getDefaultColorSetForStatsFranceMap",
    }),

    hoveredDepartmentData() {
      if (this.currentHoveredId) {
        return this.ordersSortedByDepartment.find(
          (departmentData) => departmentData.value === this.currentHoveredId,
        );
      }

      return false;
    },
  },

  methods: {
    setPathsListeners() {
      const paths = document.querySelectorAll("#map-wrapper path");
      paths.forEach((path) => {
        let id;
        let isIdf = false;

        if (path.id.startsWith("IDF")) {
          id = path.id.replace("IDF-", "");
          isIdf = true;
        } else {
          id = path.id.replace("FR-", "");
        }

        const correspondingData = this.ordersSortedByDepartment.find(
          (departmentData) => departmentData.value === id,
        );

        if (correspondingData?.ratioPercentage > 0) {
          path.setAttribute(
            "fill",
            this.getColor(correspondingData.ratioPercentage),
          );
        }

        path.addEventListener("mouseover", () => {
          if (!path.hasAttribute("stroke-width")) {
            path.setAttribute("stroke-width", isIdf ? ".6" : "3");
          }

          this.currentHoveredId = id;
        });

        path.addEventListener("mouseout", () => {
          if (path.hasAttribute("stroke-width")) {
            path.removeAttribute("stroke-width");
          }

          if (this.currentHoveredId === id) {
            this.currentHoveredId = null;
          }
        });
      });
    },

    getColor(percentage) {
      if (percentage < 25) {
        return "#f78c40";
      }

      if (percentage < 50) {
        return "#ffc107";
      }

      if (percentage < 75) {
        return "#B6D96A";
      }

      if (percentage >= 75) {
        return "#4CAF50";
      }
    },
  },
};
</script>

<style scoped>
.data-card {
  position: absolute;
  left: -30%;
  top: 6.5%;
  width: 300px;
  height: auto;
}
</style>
